import { call, put, takeLatest } from 'redux-saga/effects';

import { ActionKeys } from '~/actions/constants';
import * as invoiceAdjustmentsActions from '~/actions/invoice-adjustments.actions';
import * as invoiceAdjustmentsService from '~/services/invoice-adjustments.service';
import { fromJSON } from '~/types/InvoiceAdjustment';

export function* fetchInvoiceAdjustmentsOfInvoice(
  action: ReturnType<typeof invoiceAdjustmentsActions.fetchInvoiceAdjustmentsOfInvoice>,
) {
  try {
    const {
      data: { results },
    }: invoiceAdjustmentsService.JSONInvoiceAdjustmentResponse = yield call(
      invoiceAdjustmentsService.getInvoiceAdjustmentsOfInvoice,
      action.payload.invoiceId,
    );

    yield put(
      invoiceAdjustmentsActions.fetchInvoiceAdjustmentsOfInvoiceSuccess(results.map(fromJSON)),
    );
  } catch (e) {
    // TODO: This is likely a bug, e is probably an Error, isn't it?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield put(invoiceAdjustmentsActions.fetchInvoiceAdjustmentsOfInvoiceError(e as any));
  }
}

export default [
  takeLatest(ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH, fetchInvoiceAdjustmentsOfInvoice),
];
